import React, { useState, useEffect } from "react";
import { Table, Button } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

export default function Resulthistory() {
  const user_id = localStorage.getItem("userid");
  const devid = localStorage.getItem("dev_id");
  const { date } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalComm, settotalComm] = useState(0);
  const [totalPlayed, settotalPlayed] = useState(0);
  const [Refcomm, setRefcomm] = useState(0);
  const [RefBonus, setRefBonus] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showButton, setShowButton] = useState(false);
  const [ref_message, setref_message] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);

  const [redeemAmount, setRedeemAmount] = useState("");
  const [TotalBonus, setTotalBonus] = useState("");
  const [BonusMin, setBonusMin] = useState("");
  const [BonusMax, setBonusMax] = useState("");
  const [error, setError] = useState("");
  const [loadingbutton, setLoadingbutton] = useState(false);
  const [refData, setRefData] = useState({ ref_code: "", ref_by: "" });
  const [loadButton, setLoadButton] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(20);

  // ---------------- PROFILE ----------------
  const getProfile = async () => {
    setLoadButton(false);
    const apiUrl = `${process.env.REACT_APP_API_URL_NODE}user-profile`;
    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id,
      device_id: devid,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const res = await response.json();
      setLoadButton(true);

      if (res.is_login === "0") window.location.href = "/";
      if (res.success === "1") {
        setApiResponse(res.data.is_bonus);
        setref_message(res.data.ref_message);
        setRefData({ ref_code: res.data.ref_code, ref_by: res.data.ref_by });
        setShowButton(!res.data.ref_by);
      } else {
        console.error("API Error:", res.message);
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- SEARCH ----------------
  const handleSearch = (value) => {
    const filtered = data.filter((item) =>
      Object.values(item).some(
        (field) =>
          typeof field === "string" &&
          field.toLowerCase().includes(value.toLowerCase())
      )
    );
    setSearchText(value);
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  // ---------------- LEVEL 1 LIST ----------------
  const bonuslist = async () => {
    const uid = localStorage.getItem("userid");

    const requestData = {
      user_id: uid,
      app_id: "com.babaji.galigame",
    };

    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL_NODE}report-lavel1`,
      headers: { "Content-Type": "application/json" },
      data: requestData,
    };

    try {
      const response1 = await axios(config);
      let response = response1.data;

      // agar decrypt ke baad string aaye to object bana lo
      if (typeof response === "string") {
        try {
          response = JSON.parse(response);
        } catch (e) {
          console.error("JSON parse failed:", e);
        }
      }

      console.log("Response:", response, typeof response);

      if (String(response?.status) === "1" || String(response?.success) === "1") {
        const level1Rows = Array.isArray(response.level1) ? response.level1 : [];
        const dataRows = Array.isArray(response.data) ? response.data : [];

        const base = level1Rows.length > 0 ? level1Rows : dataRows;
        const rows = base.map((r) => {
          const extra =
            dataRows.find(
              (d) => d._id === r._id || d.user_id === r.user_id
            ) || {};
          return { ...r, ...extra };
        });

        console.log("ROWS:", rows);
        console.log("FIRST ROW KEYS:", Object.keys(rows[0] || {}));

        setData(rows);
        settotalPlayed(response.totalPlayedTotalLavel1 ?? 0);
        settotalComm(response.totalWinTotalLavel1 ?? 0);
        setRefcomm(response.commissionRate ?? 0);
        setRefBonus(response.bonusRedeemSum ?? []);
        setTotalBonus(response.common?.bonus_commission ?? 0);
        setBonusMin(response.bounsmin ?? 0);
        setBonusMax(response.bounsmax ?? 0);
      } else {
        console.log("No record found");
        setData([]);
      }
    } catch (err) {
      console.error("Error fetching user data:", err);
      if (err.response) {
        console.error("API Error Response:", err.response.data);
      }
    }
  };

  useEffect(() => {
    bonuslist();
    getProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 0);
    return () => clearTimeout(timer);
  }, []);

  // ---------------- TABLE COLUMNS ----------------
  const columns = [
    {
      title: "Mobile",
      dataIndex: "mob",
      key: "mob",
    },
    {
      title: "Ref Code",
      dataIndex: "ref_code",
      key: "ref_code",
    },
    {
      title: "Ref By",
      dataIndex: "ref_by",
      key: "ref_by",
    },
  ];

  // ---------------- REDEEM ----------------
  const redeemBonus = async (event) => {
    event.preventDefault();
    if (
      !redeemAmount ||
      Number(redeemAmount) < Number(BonusMin) ||
      Number(redeemAmount) > Number(BonusMax)
    ) {
      setError(
        "Please enter a valid amount between " + BonusMin + " and " + BonusMax
      );
      return;
    }
    setError("");
    setLoadingbutton(true);

    const requestData = { user_id, amount: redeemAmount };

    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL_NODE}bonus-report-redem`,
      headers: { "Content-Type": "application/json" },
      data: requestData,
    };

    try {
      const response1 = await axios(config);
      const response = response1.data;

      if (response.data.success == "1") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your bonus has been redeemed successfully!",
        });
        bonuslist();
        setTimeout(() => window.location.reload(), 3000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
    } catch (err) {
      console.error("Error redeeming bonus:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while redeeming your bonus. Please try again later.",
      });
    } finally {
      setLoadingbutton(false);
    }
  };

  const loadMore = () => setItemsToShow((n) => n + 20);

  // ---------------- COPY ----------------
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(
        "https://ranabhaimatka.com/create-account?reffercode=" +
          refData.ref_code
      )
      .then(() =>
        Swal.fire(
          "Copied!",
          "Your refer Link has been copied to the clipboard.",
          "success"
        )
      )
      .catch((err) => {
        console.error("Failed to copy: ", err);
        Swal.fire("Error", "Failed to copy the refer code.", "error");
      });
  };

  const copyToClipboard1 = () => {
    navigator.clipboard
      .writeText(refData.ref_code)
      .then(() =>
        Swal.fire(
          "Copied!",
          "Your refer Code has been copied to the clipboard.",
          "success"
        )
      )
      .catch((err) => {
        console.error("Failed to copy: ", err);
        Swal.fire("Error", "Failed to copy the refer code.", "error");
      });
  };

  // ---------------- UI ----------------
  const tableSource = searchText ? filteredData : data;

  return (
    <div>
      {isLoading && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}
      {!isLoading && (
        <section id="Help" className="margin-bottom-88">
          <div className="margin-bottom-49 mb-0">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <p className="referalcode">
                    अगर आप अपने रेफरल कोड से किसी को जोड़ते हैं, तो आपको उसकी
                    खेली हुई गेम का 5% कमीशन तुरंत मिलेगा।{" "}
                  </p>
                </div>

                <div className="col-md-12 mt-3">
                  <Table
                    dataSource={tableSource.slice(0, itemsToShow)}
                    columns={columns}
                    rowKey={(record) => record._id || record.user_id}
                    pagination={false}
                  />
                  {tableSource.length > itemsToShow && (
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <Button onClick={loadMore}>Load More</Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}